/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const goodLuckCoreDTOsTeamChampionStatsDtoSchema = z.object({
  championName: z.string().nullish(),
  games: z.optional(z.int()),
  wins: z.optional(z.int()),
  winrate: z.optional(z.number()),
  avgKills: z.optional(z.number()),
  avgDeaths: z.optional(z.number()),
  avgAssists: z.optional(z.number()),
});
